(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-pot-bundle-landing-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function whenReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSelectedOption(select) {
      return select.options[select.selectedIndex];
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'ar-EG', {
          style: 'currency',
          currency: currency || 'EGP',
          maximumFractionDigits: 0
        }).format(cents / 100);
      } catch (error) {
        return String(cents / 100) + ' EGP';
      }
    }

    function readAttribution() {
      var keys = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'fbclid',
        'campaign_id',
        'adset_id',
        'ad_id',
        'placement',
        'site_source_name'
      ];
      var params = new URLSearchParams(window.location.search);
      var values = {};

      keys.forEach(function (key) {
        var value = params.get(key);
        if (value) values['_' + key] = value.slice(0, 255);
      });
      return values;
    }

    function createEventId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return 'eg_bundle_' + window.crypto.randomUUID();
      }
      return 'eg_bundle_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
    }

    function publishBundleEvent(section, name, details) {
      var eventData = Object.assign(
        {
          product_id: section.dataset.productId,
          item_name: section.dataset.productName,
          currency: section.dataset.currency || 'EGP',
          page_location: window.location.href
        },
        details || {}
      );

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ecommerce: eventData });

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        var publication = window.Shopify.analytics.publish('egyptgoods_' + name, eventData);
        if (publication && typeof publication.catch === 'function') publication.catch(function () {});
      }
    }

    function initialize(section) {
      if (section.dataset.bundleReady === 'true') return;
      section.dataset.bundleReady = 'true';

      var form = section.querySelector('[data-bundle-form]');
      if (!form) return;

      var firstSelect = form.querySelector('[data-bundle-color="first"]');
      var secondSelect = form.querySelector('[data-bundle-color="second"]');
      var errorElement = form.querySelector('[data-bundle-error]');
      var submitButton = form.querySelector('[data-bundle-submit]');
      var priceElement = section.querySelector('[data-bundle-price]');

      function setError(message) {
        errorElement.textContent = message || '';
        errorElement.hidden = !message;
      }

      function updatePrice() {
        var firstOption = getSelectedOption(firstSelect);
        var secondOption = getSelectedOption(secondSelect);
        var cents = Number(firstOption.dataset.price || 0) + Number(secondOption.dataset.price || 0);
        if (priceElement && cents > 0) {
          priceElement.textContent = formatMoney(cents, section.dataset.currency);
          section.dataset.productValue = String(cents / 100);
        }
      }

      firstSelect.addEventListener('change', function () {
        setError('');
        updatePrice();
      });
      secondSelect.addEventListener('change', function () {
        setError('');
        updatePrice();
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        setError('');

        var firstOption = getSelectedOption(firstSelect);
        var secondOption = getSelectedOption(secondSelect);
        if (!firstOption.value || !secondOption.value) {
          setError(section.dataset.errorGeneric);
          return;
        }
        if (firstOption.value === secondOption.value) {
          setError(section.dataset.errorSameColor);
          secondSelect.focus();
          return;
        }

        var totalCents = Number(firstOption.dataset.price || 0) + Number(secondOption.dataset.price || 0);
        var bundleId = createEventId();
        var sharedProperties = Object.assign(
          {
            '_Bundle offer': 'ML904 choose 2',
            '_Bundle ID': bundleId,
            '_Selected color 1': firstOption.dataset.color,
            '_Selected color 2': secondOption.dataset.color
          },
          readAttribution()
        );
        var items = [
          {
            id: Number(firstOption.value),
            quantity: 1,
            properties: Object.assign({}, sharedProperties, { '_Bundle slot': '1' })
          },
          {
            id: Number(secondOption.value),
            quantity: 1,
            properties: Object.assign({}, sharedProperties, { '_Bundle slot': '2' })
          }
        ];

        submitButton.disabled = true;
        submitButton.textContent = section.dataset.buttonLoading;
        publishBundleEvent(section, 'bundle_add_attempted', {
          content_ids: [firstOption.dataset.sku, secondOption.dataset.sku],
          value: totalCents / 100,
          bundle_id: bundleId
        });

        fetch(section.dataset.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok) throw payload;
              return payload;
            });
          })
          .then(function () {
            var trackingData = {
              content_ids: [firstOption.dataset.sku, secondOption.dataset.sku],
              contents: [
                { id: firstOption.dataset.sku, quantity: 1 },
                { id: secondOption.dataset.sku, quantity: 1 }
              ],
              content_type: 'product',
              content_name: section.dataset.productName,
              value: totalCents / 100,
              currency: section.dataset.currency || 'EGP',
              num_items: 2
            };

            publishBundleEvent(section, 'bundle_cart_added', Object.assign({ bundle_id: bundleId }, trackingData));

            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart', trackingData, { eventID: bundleId + '_cart' });
              if (typeof window.__egSendInitiateCheckout === 'function') {
                window.__egSendInitiateCheckout(trackingData, bundleId + '_checkout');
              } else {
                window.fbq('track', 'InitiateCheckout', trackingData, { eventID: bundleId + '_checkout' });
              }
            }

            window.location.assign(section.dataset.checkoutUrl);
          })
          .catch(function (error) {
            var message = error && (error.description || error.message);
            setError(message || section.dataset.errorGeneric);
            publishBundleEvent(section, 'bundle_add_failed', {
              bundle_id: bundleId,
              error_category: 'cart_add'
            });
            submitButton.disabled = false;
            submitButton.textContent = section.dataset.buttonIdle;
          });
      });

      updatePrice();
    }

    whenReady(function () {
      document.querySelectorAll('[data-coffee-bundle]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coffee-pot-bundle-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function whenReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function getSelectedOption(select) {
      return select.options[select.selectedIndex];
    }

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'ar-EG', {
          style: 'currency',
          currency: currency || 'EGP',
          maximumFractionDigits: 0
        }).format(cents / 100);
      } catch (error) {
        return String(cents / 100) + ' EGP';
      }
    }

    function readAttribution() {
      var keys = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'fbclid',
        'campaign_id',
        'adset_id',
        'ad_id',
        'placement',
        'site_source_name'
      ];
      var params = new URLSearchParams(window.location.search);
      var values = {};

      keys.forEach(function (key) {
        var value = params.get(key);
        if (value) values['_' + key] = value.slice(0, 255);
      });
      return values;
    }

    function createEventId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return 'eg_bundle_' + window.crypto.randomUUID();
      }
      return 'eg_bundle_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
    }

    function publishBundleEvent(section, name, details) {
      var eventData = Object.assign(
        {
          product_id: section.dataset.productId,
          item_name: section.dataset.productName,
          currency: section.dataset.currency || 'EGP',
          page_location: window.location.href
        },
        details || {}
      );

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ecommerce: eventData });

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        var publication = window.Shopify.analytics.publish('egyptgoods_' + name, eventData);
        if (publication && typeof publication.catch === 'function') publication.catch(function () {});
      }
    }

    function initialize(section) {
      if (section.dataset.bundleReady === 'true') return;
      section.dataset.bundleReady = 'true';

      var form = section.querySelector('[data-bundle-form]');
      if (!form) return;

      var firstSelect = form.querySelector('[data-bundle-color="first"]');
      var secondSelect = form.querySelector('[data-bundle-color="second"]');
      var errorElement = form.querySelector('[data-bundle-error]');
      var submitButton = form.querySelector('[data-bundle-submit]');
      var priceElement = section.querySelector('[data-bundle-price]');

      function setError(message) {
        errorElement.textContent = message || '';
        errorElement.hidden = !message;
      }

      function updatePrice() {
        var firstOption = getSelectedOption(firstSelect);
        var secondOption = getSelectedOption(secondSelect);
        var cents = Number(firstOption.dataset.price || 0) + Number(secondOption.dataset.price || 0);
        if (priceElement && cents > 0) {
          priceElement.textContent = formatMoney(cents, section.dataset.currency);
          section.dataset.productValue = String(cents / 100);
        }
      }

      firstSelect.addEventListener('change', function () {
        setError('');
        updatePrice();
      });
      secondSelect.addEventListener('change', function () {
        setError('');
        updatePrice();
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        setError('');

        var firstOption = getSelectedOption(firstSelect);
        var secondOption = getSelectedOption(secondSelect);
        if (!firstOption.value || !secondOption.value) {
          setError(section.dataset.errorGeneric);
          return;
        }
        if (firstOption.value === secondOption.value) {
          setError(section.dataset.errorSameColor);
          secondSelect.focus();
          return;
        }

        var totalCents = Number(firstOption.dataset.price || 0) + Number(secondOption.dataset.price || 0);
        var bundleId = createEventId();
        var sharedProperties = Object.assign(
          {
            '_Bundle offer': 'ML904 choose 2',
            '_Bundle ID': bundleId,
            '_Selected color 1': firstOption.dataset.color,
            '_Selected color 2': secondOption.dataset.color
          },
          readAttribution()
        );
        var items = [
          {
            id: Number(firstOption.value),
            quantity: 1,
            properties: Object.assign({}, sharedProperties, { '_Bundle slot': '1' })
          },
          {
            id: Number(secondOption.value),
            quantity: 1,
            properties: Object.assign({}, sharedProperties, { '_Bundle slot': '2' })
          }
        ];

        submitButton.disabled = true;
        submitButton.textContent = section.dataset.buttonLoading;
        publishBundleEvent(section, 'bundle_add_attempted', {
          content_ids: [firstOption.dataset.sku, secondOption.dataset.sku],
          value: totalCents / 100,
          bundle_id: bundleId
        });

        fetch(section.dataset.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok) throw payload;
              return payload;
            });
          })
          .then(function () {
            var trackingData = {
              content_ids: [firstOption.dataset.sku, secondOption.dataset.sku],
              contents: [
                { id: firstOption.dataset.sku, quantity: 1 },
                { id: secondOption.dataset.sku, quantity: 1 }
              ],
              content_type: 'product',
              content_name: section.dataset.productName,
              value: totalCents / 100,
              currency: section.dataset.currency || 'EGP',
              num_items: 2
            };

            publishBundleEvent(section, 'bundle_cart_added', Object.assign({ bundle_id: bundleId }, trackingData));

            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart', trackingData, { eventID: bundleId + '_cart' });
              if (typeof window.__egSendInitiateCheckout === 'function') {
                window.__egSendInitiateCheckout(trackingData, bundleId + '_checkout');
              } else {
                window.fbq('track', 'InitiateCheckout', trackingData, { eventID: bundleId + '_checkout' });
              }
            }

            window.location.assign(section.dataset.checkoutUrl);
          })
          .catch(function (error) {
            var message = error && (error.description || error.message);
            setError(message || section.dataset.errorGeneric);
            publishBundleEvent(section, 'bundle_add_failed', {
              bundle_id: bundleId,
              error_category: 'cart_add'
            });
            submitButton.disabled = false;
            submitButton.textContent = section.dataset.buttonIdle;
          });
      });

      updatePrice();
    }

    whenReady(function () {
      document.querySelectorAll('[data-coffee-bundle]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
